// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3QzRV","messages":"Chat_messages__2ibVz","dateDivider":"Chat_dateDivider__DrO0W"};